// i18n
import { useTranslation } from 'react-i18next';

// types
import { Entity, Loan } from '../../../../@types';

// mui
import { Container, Grid, Typography } from '@mui/material';

// cards
import { CardLoans } from '../../../cards/CardLoans/CardLoans';
import { CardMetadata } from '../../../cards/CardMetadata/CardMetadata';
import { CardTraceability } from '../../../cards/CardTraceability/CardTraceability';

// config
import { featureFlags } from '../../../../config/featureFlags';

// props
export interface DetailsProps {
	beneficiary: Entity;
	isLoadingLoans?: boolean;
	loans: Loan[];
}

export const Details = ({ isLoadingLoans, loans, beneficiary }: DetailsProps) => {
	// hooks
	const { t } = useTranslation();

	const colWidthMetadata = {
		xs: 12,
		md: 12,
		lg: 6,
		xl: 4.5,
	};

	const colWidthLoans = {
		xs: 12,
		md: 6,
		lg: 3,
		xl: 3,
	};

	if (featureFlags['FINANCIAL_TRACEABILITY']) {
		colWidthMetadata.md = 6;
		colWidthLoans.lg = 6;
		colWidthLoans.xl = 2.5;
	}

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Typography variant="h2">{t('details')}</Typography>
				</Grid>
				<Grid item {...colWidthMetadata}>
					<CardMetadata entity={beneficiary} loans={loans} />
				</Grid>
				<Grid item {...colWidthLoans}>
					<CardLoans isLoading={isLoadingLoans} loans={loans} />
				</Grid>
				<Grid item xs={12} md={true}>
					<CardTraceability
						DialogProps={{
							subtitle: {
								children: beneficiary.name,
							},
						}}
						traceability={beneficiary.traceability}
						type="TRANSACTIONS"
					/>
				</Grid>
				{featureFlags['FINANCIAL_TRACEABILITY'] && (
					<Grid item xs={12} md={6} lg={true}>
						<CardTraceability
							DialogProps={{
								subtitle: {
									children: beneficiary.name,
								},
							}}
							traceability={beneficiary.traceability}
							type="FINANCIAL"
						/>
					</Grid>
				)}
			</Grid>
		</Container>
	);
};
